import { useRef, useEffect, useMemo } from 'react'
import emojiRegex from 'emoji-regex'

export const useDidUpdate = (
  callback: () => void,
  deps: React.DependencyList
) => {
  const hasMount = useRef(false)

  useEffect(() => {
    if (hasMount.current) {
      callback()
    } else {
      hasMount.current = true
    }
  }, deps)
}

const emojiReg = emojiRegex()

export const useEmojiOnly = (content: string) =>
  useMemo(() => {
    // trzeba dwa razy bo jak się dwa razy odpali na tej samej emotce
    // to co drugie nie wykrywa
    const emoji = emojiReg.exec(content) || emojiReg.exec(content)

    return emoji && emoji[0] == content ? true : false
  }, [])
